<template>
  <div id="app">
    <div v-if="web_status == 1">
      <keep-alive :include="keepAliveRoute" v-if="isRouterAlive">
        <router-view />
      </keep-alive>
      <Tabbar v-if="show" />
      <Tabbars v-if="showBoss" />
    </div>
    <div class="web_close_msg" v-else>
      <div>{{ web_close_msg }}</div>
    </div>
  </div>
</template>
<script>
var wx = require("weixin-js-sdk");
import { wechatApi, commonConfig } from "@/api/apiData";
import Tabbar from "./components/tabBar/tabbar";
import Tabbars from "./components/tabBar/tabBoss";
import { mapMutations, mapState } from "vuex";
// import { Token } from "@/until/tokenCheck";
import { tokenCheck } from "@/api/apiData";
import store from "@/store/index";
import { Dialog } from "vant";
export default {
  components: { Tabbar, Tabbars },
  provide() {
    return {
      reload: this.reload,
      Token: this.tokenChecks,
      getWechatApi: this.getWechatApi,
    };
  },
  data() {
    return {
      show: false,
      showBoss: false,
      isRouterAlive: true,
      web_status: 0,
      web_close_msg: "",
      // keepAlive: ""
    };
  },
  computed: {
    ...mapState(["keepAliveRoute"]),
  },
  watch: {
    $route(e) {
      // this.keepAlive =e.meta.keepAlive;
      // e.name == "Interpretation" ||
      // e.name == "Ideology"
      //         e.name == "Home" ||
      // //(e);
      if (
        e.name == "Profile" ||
        e.name == "Index" ||
        e.name == "Train" ||
        e.name == "Activity" ||
        e.name == "contant"
      ) {
        this.show = true;
        this.showBoss = false;
        switch (e.name) {
          case "Profile":
            this.$store.commit("SETT_ABBAR", "3");
            break;
          // case "Home":
          //   this.$store.commit("SETT_ABBAR", "1");
          //   break;
          case "Index":
            this.$store.commit("SETT_ABBAR", "0");
            break;
          case "contant":
            this.$store.commit("SETT_ABBAR", "2");
            break;
          case "Activity":
            if (e.params.type != 0) {
              this.$store.commit("SETT_ABBAR", "1");
            } else {
              this.show = false;
            }
            break;
          // case "Ideology":
          //   this.$store.commit("SETT_ABBAR", "2");
          //   break;
        }
      } else if (
        e.name == "HomeBoss" ||
        e.name == "Ment" ||
        e.name == "Recommend" ||
        e.name == "Mine"
      ) {
        this.showBoss = true;
        this.show = false;

        switch (e.name) {
          case "HomeBoss":
            this.$store.commit("SET_TABS", {
              index: "0",
              type: "0",
            });
            break;
          case "Recommend":
            this.$store.commit("SET_TABS", {
              index: "1",
              type: "1",
            });
            break;
          case "Ment":
            this.$store.commit("SET_TABS", {
              index: "2",
              type: "0",
            });
            break;
          case "Mine":
            this.$store.commit("SET_TABS", {
              index: "3",
              type: "0",
            });
            break;
        }
      } else {
        this.show = false;
        this.showBoss = false;
      }
    },
  },
  methods: {
    // 获取网站配置
    getConfig() {
      commonConfig().then((res) => {
        if (res.code == 1) {
          this.web_status = res.data.web_status;
          this.web_close_msg = res.data.web_close_msg;
        }
      });
    },
    // 刷新
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    // 获取微信api
    getWechatApi(url, title, img) {
      const that = this;
      wechatApi().then((res) => {
        if (res.code == 1) {
          this.wechatShare(res.data, url, title, img);
        }
      });
    },
    // 分享设置
    wechatShare(data, url, title, img) {
      var appId = data.appId;
      var timestamp = data.timestamp;
      var nonceStr = data.nonceStr;
      var signature = data.signature;
      wx.config({
        debug: data.debug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: appId, // 必填，公众号的唯一标识
        timestamp: timestamp, // 必填，生成签名的时间戳
        nonceStr: nonceStr, // 必填，生成签名的随机串
        signature: signature, // 必填，签名，见附录1
        jsApiList: data.jsApiList, // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });

      wx.ready(function () {
        var desc = "";
        var imgurl = img;
        wx.onMenuShareTimeline({
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: data.url + url, // 分享链接
          imgUrl: img, // 分享图标
          success: function () {
            // 用户确认分享后执行的回调函数
          },
          cancel: function () {
            // 用户取消分享后执行的回调函数
          },
        });

        wx.onMenuShareAppMessage({
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: data.url + url, // 分享链接
          imgUrl: imgurl, // 分享图标
          type: "", // 分享类型,music、video或link，不填默认为link
          dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
          success: function () {
            // 用户确认分享后执行的回调函数
          },
          cancel: function () {
            // 用户取消分享后执行的回调函数
          },
        });

        wx.onMenuShareQQ({
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: data.url + url, // 分享链接
          imgUrl: imgurl, // 分享图标
          success: function () {
            // 用户确认分享后执行的回调函数
          },
          cancel: function () {
            // 用户取消分享后执行的回调函数
          },
        });
      });
    },
    // token验证
    tokenChecks(fun) {
      var that = this;
      var token = store.state.token;
      var type = store.state.loginType;

      if (type == 2) {
        that.$router.replace({
          name: "HomeBoss",
        });
      }
      if (token == "") {
        // 未登陆
        Dialog.confirm({
          title: "提示",
          message: "您还没有登录,是否现在就去登录~",
        })
          .then(() => {
            window.location.href =
              "https://ncxtyjrwork.nccloudmedia.com/web/#/login/account";
            //  window.location.href = "http://192.168.9.173:8085/#/login/account";
            // that.$router.replace({
            //   name: "Login"
            // });
          })
          .catch(() => {
            that.$router.replace({
              name: "Index",
            });
          });
      } else {
        // 已登陆
        tokenCheck().then((res) => {
          // 验证Token
          if (res.code != 1) {
            Dialog.confirm({
              title: "提示",
              message: "登陆已过期,是否现在就去登录~",
            })
              .then(() => {
                window.location.href =
                  "https://ncxtyjrwork.nccloudmedia.com/web/#/login/account";
              })
              .catch(() => {
                that.$router.replace({
                  name: "Index",
                });
              });
          } else {
            return typeof fun == "function" && fun();
          }
        });
      }
    },
  },

  mounted() {
    this.getConfig();
  },
};
</script>
<style lang="less">
.web_close_msg {
  font-size: 24px;
  text-align: center;
  line-height: 8;
  color: #f44336;
}
#app {
  .life {
    .van-tab--active {
      font-size: 0.28rem;
    }
    .van-nav-bar .van-icon {
      color: #323233;
    }
  }
  img {
    image-rendering: -moz-crisp-edges;
    image-rendering: -o-crisp-edges;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor;
  }
  .Hei {
    font-family: "Hei";
  }
  div {
    box-sizing: border-box;
  }
  // 顶部导航自适应
  /deep/.van-nav-bar {
    height: 0.8rem;
    .van-nav-bar__title {
      font-size: 0.32rem;
      font-weight: bold;
      color: #333333;
    }
  }
  button,
  input {
    border: 1px solid transparent; //自定义边框
    outline: none; //消除默认点击蓝色边框效果
    box-sizing: border-box;
  }
  p {
    margin: 0;
  }
  img {
    display: block;
  }
  // 保存取消按钮
  .btn {
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    padding: 0.25rem 0.32rem 0.3rem;
    display: flex;
    align-items: center;
    font-size: 0.28rem;
    background: #fff;
    .clear,
    .confirm {
      flex: 1;
      padding: 0.2rem 0;
      background: rgba(247, 247, 247, 1);
      border-radius: 0.08rem;
      color: #666666;
    }
    .confirm {
      flex: 1.5;
      background: rgba(255, 67, 67, 1);
      margin-left: 0.3rem;
      color: #ffffff;
    }
  }
  // 申请按钮
  .request-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0.25rem 0.32rem;
    box-shadow: 0 -0.01rem 0 rgba(0, 0, 0, 0.08);
    border-top: 0.01rem solid rgba(178, 178, 178, 0.5);
    z-index: 10;
    background: #fff;
    display: flex;
    align-items: center;
    .btns {
      width: 100%;
      height: 0.8rem;
      line-height: 0.8rem;
      font-size: 0.28rem;
      background: rgba(255, 67, 67, 1);
      border-radius: 0.08rem;
      color: #ffffff;
    }
  }
  // 导航栏返回箭头
  .back {
    width: 0.4rem;
    height: 0.4rem;
  }
  #board {
    .van-nav-bar {
      background: #e23a2d !important;
      z-index: 10 !important;
    }
    .van-nav-bar .van-icon,
    .van-nav-bar__title {
      color: #fff !important;
    }
  }
  .edui-upload-video {
    width: 100% !important;
    height: auto !important;
  }
}
</style>
